import ApiKeys from 'app/collections/api_keys';
import ApiKey from 'app/models/api_key';
import ApiModeSelection from 'app/models/api_mode_selection';

import Base from 'app/views/base';

import PageHeaderView from 'app/components/page_header';
import PanelList from 'app/components/panel_list';
import PopupCreateFormView from 'app/components/popup_create_form';
import ListItemView from './list_item_view';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'api-keys',

  initialize() {
    this.collection = new ApiKeys([], {});

    const createNewAPIKeyView = new PopupCreateFormView({
      title: 'Add Additional API Key',
      objectName: 'API Key',
      ModelClass: ApiKey,
      dropdownSelections: [
        new ApiModeSelection({}),
      ],
    });
    this.listenTo(createNewAPIKeyView, 'create', () => this.collection.fetch({ reset: true }));

    this.addSubview('header', 'header', new PageHeaderView({
      name: 'API Keys',
      links: [
        { name: 'Docs', href: '/docs/api#authentication' },
        { name: 'Guide', href: '/getting-started' },
      ],
      subViews: [ createNewAPIKeyView ],
    }));
    this.addSubview('prodApiKeysList', '#prod_api_keys_list', new PanelList({
      title: 'Production API Keys',
      ListItemView: ListItemView,
      collection: this.collection,
      contextWhere: { mode: 'production' },
    }));
    this.addSubview('testApiKeysList', '#test_api_keys_list', new PanelList({
      title: 'Test API Keys',
      ListItemView: ListItemView,
      collection: this.collection,
      contextWhere: { mode: 'test' },
      fetch: false,
    }));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/api_keys/index.js